module.exports = __webpack_public_path__ + "static/media/cat_bewolkt.a83bc0b7.png";